import { render, staticRenderFns } from "./BarIcon.vue?vue&type=template&id=e39b3550&scoped=true"
import script from "./BarIcon.vue?vue&type=script&lang=js"
export * from "./BarIcon.vue?vue&type=script&lang=js"
import style0 from "./BarIcon.vue?vue&type=style&index=0&id=e39b3550&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e39b3550",
  null
  
)

export default component.exports